import AboutSection from "../components/AboutSection";
import AskForDetail from "../components/AskForDetail";
import AboutOemSection from "../components/AboutOemSection";
import AboutTimelineSection from "../components/AboutTimelineSection";

function AboutPage() {
    return (
        <>
            <AboutOemSection/>
            <AboutSection/>
            <AboutTimelineSection/>
            <AskForDetail/>
        </>
    );
}

export default AboutPage;